<div class="loading-container" [class.overlay]="overlay">
  <div class="loading-spinner" [class.small]="size === 'small'" [class.large]="size === 'large'">
    <div class="spinner-ring"></div>
    <div class="spinner-ring"></div>
    <div class="spinner-ring"></div>
    <div class="spinner-ring"></div>
  </div>
  <div class="loading-message" *ngIf="message">{{ message }}</div>
</div>
